import "core-js/modules/es.array.push.js";
import ImageGenerate from '@/Painting/imagegenerate/entrance.vue';
const PLACEHOLDER = require('@/assets/painting/all_bg.jpg');

// 裁剪形状图标默认尺寸（与历史静态页保持一致）
const DEFAULT_SQUARE = {
  width: 64,
  height: 64
};
const DEFAULT_HORIZONTAL = {
  width: 80,
  height: 48
};
const DEFAULT_VERTICAL = {
  width: 48,
  height: 80
};
function ensureShapeObject(value, fallbackSize) {
  if (!value) return null;
  // 接口可能返回字符串 URL，或已经是 { image, width, height }
  if (typeof value === 'string') {
    return {
      image: value,
      width: fallbackSize.width,
      height: fallbackSize.height
    };
  }
  if (typeof value === 'object') {
    const image = value.image || value.url || value.src || null;
    if (!image && typeof value === 'object') return null;
    return {
      image: image || value,
      width: value.width || fallbackSize.width,
      height: value.height || fallbackSize.height
    };
  }
  return null;
}
function ensureArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (value == null) {
    return [];
  }
  return [value];
}
export default {
  name: 'DefaultTemplateRenderer',
  components: {
    ImageGenerate
  },
  props: {
    template: {
      type: Object,
      required: true
    },
    productMeta: {
      type: Object,
      required: true
    }
  },
  computed: {
    carouselImages() {
      const list = ensureArray(this.template.carouselImages);
      const filled = list.filter(Boolean);
      while (filled.length < 6) {
        filled.push(PLACEHOLDER);
      }
      return filled.slice(0, 6);
    },
    headImg() {
      return this.template.headImgUrl || PLACEHOLDER;
    },
    exampleOriginal() {
      return this.template.exampleOriginal || PLACEHOLDER;
    },
    exampleTarget() {
      return this.template.exampleTarget || PLACEHOLDER;
    },
    shopUrl() {
      return this.template.shopUrl || this.productMeta && this.productMeta.shopUrl || '';
    },
    productName() {
      if (this.template.productName) {
        return this.template.productName;
      }
      if (this.productMeta && this.productMeta.slug) {
        return this.productMeta.slug;
      }
      return 'product';
    },
    widthHeightRatio() {
      if (typeof this.template.widthHeightRatio === 'number') {
        return this.template.widthHeightRatio;
      }
      return -1;
    },
    productIntroduce() {
      const introduce = this.template.productIntroduce;
      if (!introduce) {
        return '';
      }
      if (typeof introduce === 'string') {
        return introduce;
      }
      const {
        zh,
        en
      } = introduce;
      return zh || en || '';
    },
    // 将后端字符串 URL 转为裁剪组件所需对象结构
    cropShapeSquareObject() {
      return ensureShapeObject(this.template.cropShapeSquareImage, DEFAULT_SQUARE);
    },
    cropShapeHorizontalObject() {
      return ensureShapeObject(this.template.cropShapeHorizontalImage, DEFAULT_HORIZONTAL);
    },
    cropShapeVerticalObject() {
      return ensureShapeObject(this.template.cropShapeVerticalImage, DEFAULT_VERTICAL);
    }
  }
};